import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ShippingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    margin: ${({ isCondensedView }) =>
        isCondensedView ? '-14px 0 0 0;' : '18px 0 0 0'};
    ${media.mobileDevice`
       margin:${({ isCondensedView }) =>
       isCondensedView ? '0px 0 0 0' : '16px 0 0 0'};
    `};
`;

export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: auto;
    padding: ${({ padding }) => (padding ? padding : '5px 10px')};
    & .template {
        font-size: 14px;
        color: #140f4b;
        font-family: AvenirNextWorld Regular;
    }
`;

export const PriceContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    margin-left: 0;
    ${media.mediumDevice`
        margin-left: 195px;
        margin-top: -46px
    `}
    ${media.mobileDevice`
        justify-content:flex-start;
        margin-left: 0px;
    `}
`;

export const ShippingTitle = styled.p`
    font-family: 'AvenirNextWorld Bold';
    font-size: 20px;
    color: #140f4b;
    opacity: 1;
    margin: 0 0 12px 0;
    padding: 0px;
    ${media.mobileDevice`
        font-family: 'AvenirNextWorld Demi';
        font-size: 22px;
        color:#202124;
    `};
`;

export const ShippingAddressCardWrapper = styled.div`
    position: relative;
`;

export const ShippingAddressAccountNumber = styled.div`
    height: auto;
    margin-bottom: 3px;
`;

export const ShippingAddressLine = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const ShippingMethodContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%; 
    margin: ${({ margin }) => (margin ? margin : '5px 0 8px 0')};
`;

export const PurchaseOrderNumber = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin: 14px 0 0px 0;
`;

export const CarouselContainer = styled.div`
    height: ${(props) => props.height};
`;

export const ShipToContainerWrapper = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    width: ${(props) => props.width};
    background: ${({ backGroundcolor }) =>
        backGroundcolor ? backGroundcolor : ''};
    box-shadow: ${({ boxShadow }) => (boxShadow ? boxShadow : '')};
    margin: 0px 0 10px 0;
    border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '')};
    padding: ${({ padding }) => (padding ? padding : '')};

    height: ${({ height }) => (height ? height : '')};
    ${media.mobileDevice` 
        padding : ${({ isCondensedView, mbPadding }) => (isCondensedView ? mbPadding:'' )};
        `};
`;
export const ShipToDetailWrapper = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    width: ${(props) => props.width};
    background: ${({ backGroundcolor }) =>
        backGroundcolor ? backGroundcolor : ''};
    box-shadow: ${({ boxShadow }) => (boxShadow ? boxShadow : '')};
    margin: 10px 0 10px 0;
    border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '')};
    padding: ${({ padding }) => (padding ? padding : '')};
    gap: 20px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};

    height: ${({ height }) => (height ? height : '')};
    ${media.mobileDevice` 
        padding :  ${({ mbPadding }) => (mbPadding ? mbPadding : '')};
        gap 0px
        `};
`;
export const DontShipContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
`;

export const SelectAllDontShip = styled.div`
    display: flex;
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    color: #140f4b;
    align-items: center;
    margin: 0 0 0 6px;
`;
export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    white-space: nowrap;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
    width : 200px,
    margin-right: ${({ marginRight }) =>
        marginRight ? marginRight : null};       
    white-space: nowrap;
    margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0px')};
    `}
`;

export const AddIcon = styled.div`
    // display: ${({ display }) => (display ? display : 'contents')};
    // padding: ${({ padding }) => (padding ? padding : '0px 5px 2px')};
    float: ${({ float }) => (float ? float : 'right')};
    display: ${({ isReviewSubmitScreen, display }) =>
        isReviewSubmitScreen ? null : display ? display : 'contents'};
    padding: ${({ isReviewSubmitScreen, padding }) =>
        isReviewSubmitScreen ? null : padding ? padding : '0px 5px 2px'};
`;
export const CartHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: 1120px;
    // height: 36px;
    margin-top: 16px;
    // margin-bottom: 12px;
    ${media.mobileDevice`     
     margin-top: 0px;
    // margin-bottom: 18px;
     background: #ffffff 0% 0% no-repeat padding-box;
     box-shadow: 0px 0px 6px #00000029;
    `}
`;

export const CartHeaderTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: ${({ color }) => (color ? color : '#030330')};
    height: 36px;
    width: ${({ width }) => (width ? width : '82px')};
    font-size: 20px;
    // font-weight: 600;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 6px;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size:20px;
    width: auto;

        white-space: nowrap;
     
        margin-top: -11px;
        margin-left:  ${({ isCondensedView,marginLeft }) => (marginLeft?marginLeft:isCondensedView ? '10px' : '')};;
    `}
`;

export const CartActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    // width: 100%;
    height: 32px;
    gap: ${({ gap }) => (gap ? gap : '65px')};

    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    ${media.mobileDevice`
        gap: 58px;
        padding:${({ isCondensedView, mbPadding }) => (isCondensedView ? mbPadding : '')};
         `}
`;
export const CartActionItemsContainer = styled.div`
    display: flex;
    width: ${({ width }) => (width ? width : '244px')};
    height: 20px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '-10px')};
    // cursor: pointer;
    ${media.mobileDevice`
    //  display: none;
    width:100%;
    float:right
    // margin-right:-30px;
     margin-right: 0;
     justify-content: flex-end
     `}
`;
export const Text = styled.div`
   width: ${({ width }) => (width ? width : '83px')};
    height: ${({ height }) => (height ? height : '20px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    font-weight: 600;
    float: ${({ float }) => (float ? float : 'left')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '')};
    white-space: nowrap;
    ${media.mobileDevice`
     margin-left: 0;
     `}
`;
export const CartAction = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    display: flex;
    opacity: 1;
    //  height: 34px;
    // width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    cursor: pointer;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 22px;
     width: 40%;
    `}
`;
export const AddProductsMenuCard = styled.div`
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '')};
    margin-bottom: 10px;
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    height: ${(props) => {
        props.height ? props.height : '190px';
    }};
    width: 100%; //originally 66%
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;

    ${media.smalDevice`
        width:${(props) =>
            props.widthOnSmallDevice ? props.widthOnSmallDevice : '100%'}
    `}
    @media only screen and (min-device-width: 1024px) and
        (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        width: ${(props) => (props.mediumWidth ? props.mediumWidth : '60%')};
    }

    @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: landscape) {
        /* For landscape layouts only */
        width: ${(props) =>
            props.landScapeWidth ? props.landScapeWidth : '60%'};
    }
    ${media.mobileDevice`     
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '10px 0')};
        padding: 0 0 10px 0;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        border-radius: 0px
    `}
`;

export const AddProductsMobileMenuCard = styled.div`
    display: flex;
    height: 30px;
    position: relative;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
`;

export const AddProductsMenuCardItems = styled.div`
    display: flex;
    margin: ${({ setMargin }) => (setMargin ? setMargin : '5px')};
    padding: ${({ setPadding }) => (setPadding ? setPadding : '0px')};
    color: ${({ color }) => (color ? color : '#1010eb')};
    font-size: ${({ fonstSize }) => (fonstSize ? fonstSize : '14px')};
    cursor: none;
    width: ${({ setWidth }) => (setWidth ? setWidth : '45%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};
    position: ${({ position }) => (position ? position : 'relative')};
    left: ${({ left }) => (left ? left : '0')};
    top: ${({ top }) => (top ? top : '0')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0')};
    justify-content: flex-end;
`;

export const AddProductsMethodCardItems = styled.div`
    display: flex;
    margin: ${({ setMargin }) => (setMargin ? setMargin : '5px')};
    padding: ${({ setPadding }) => (setPadding ? setPadding : '10px')};
    color: #1010eb;
    font-size: 14px;
    //cursor: pointer;
    // width: ${({ setWidth }) => (setWidth ? setWidth : '45%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '65px')};
    ${media.mobileDevice`     
      white-space: nowrap
    `}
`;

export const RequestDeliveryDateView = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
    margin-bottom: ${({ marginBottomLarge }) =>
        marginBottomLarge ? '30px' : null};
    & p {
        padding: 0;
        margin: 0;
        text-align: center;
        width: 40%;
        color: #202124;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
    }
    @media only screen and (orientation: landscape) {
        margin-bottom: ${({ marginBottom }) => (marginBottom ? '30px' : null)};
    }
`;
